import { resolveComponent as d, createElementBlock as c, createCommentVNode as p, openBlock as l, createElementVNode as i, createVNode as u, createTextVNode as m, ref as f } from "vue";
import '../../assets/components/ServiceWorkerReload.css';/* empty css                                                             */
import { _ as g } from "../plugin-vue.CHgC5LLL.js";
const v = {
  name: "ServiceWorkerReload",
  props: {
    /**
     * The `useRegisterSWFunction` property represents a function that is used
     * to register a service worker.
     *
     * This function is typically imported from `virtual:pwa-register/vue` provided by VitePWA.
     *
     * @example
     * ```javascript
     * import { useRegisterSW } from 'virtual:pwa-register/vue';
     *
     *
     * <ServiceWorkerReload :useRegisterSWFunction="useRegisterSW" />
     * ```
     */
    useRegisterSWFunction: {
      type: Function,
      required: !0
    }
  },
  setup(n) {
    const e = f(!1), { needRefresh: r, updateServiceWorker: t } = n.useRegisterSWFunction({
      immediate: !0,
      /* v8 ignore start */
      onRegisteredSW(a, o) {
        console.debug(`Service Worker at: ${a}`), setInterval(
          async () => {
            console.debug("Checking for sw update"), await o.update();
          },
          60 * 60 * 1e3
        );
      }
      /* v8 ignore stop */
    });
    function s() {
      e.value = !0, t();
    }
    return {
      needRefresh: r,
      updating: e,
      doSWUpdate: s
    };
  }
}, b = {
  key: 0,
  class: "pwa-toast alert bg-danger text-white",
  role: "alert"
}, _ = ["disabled"];
function k(n, e, r, t, s, a) {
  const o = d("font-awesome-icon");
  return t.needRefresh ? (l(), c("div", b, [
    e[2] || (e[2] = i("div", { class: "message mb-2" }, "New app version available, click to update", -1)),
    i("button", {
      class: "btn btn-light",
      type: "button",
      disabled: t.updating,
      onClick: e[0] || (e[0] = (S) => t.doSWUpdate())
    }, [
      u(o, {
        "fixed-width": "",
        icon: "rotate",
        spin: t.updating
      }, null, 8, ["spin"]),
      e[1] || (e[1] = m(" Update "))
    ], 8, _)
  ])) : p("", !0);
}
const x = /* @__PURE__ */ g(v, [["render", k]]);
export {
  x as S
};
